export { default } from './PaginatedCardTable';
